<template>
  <mgl-marker :coordinates="lnglat"
              v-if="isInMap"
  >
    <div class="map-marker"
         :class="modifiers"
         :style="{ backgroundImage: `url('${ imageUrl }')` }"
         slot="marker"
         tabindex="0"
         @click.stop="onClick"
    >
      <div class="map-marker__count">
        <span>
          {{ imagesCount }}
        </span>
      </div>

      <div v-if="isChosen"
           class="map-marker__street"
      >
        <span v-html="streetLabel"></span>
      </div>

      <button v-if="showRouteControl"
              class="btn-default map-marker__route-control"
              :class="{'map-marker__route-control--is-inactive': isInActiveRoute}"
              @click.stop="onRouteControlClick"
      >
        <app-icon v-if="isInActiveRoute"
                  icon="is-in-route"
                  is-active
        />
        <app-icon v-else
                  icon="add-to-route"
        />
      </button>
    </div>
  </mgl-marker>

  <div v-else
       class="map-marker"
       :class="modifiers"
       :style="{ backgroundImage: `url('${ imageUrl }')` }"
       slot="marker"
       tabindex="0"
       @click.stop="onClick"
  >
    <div class="map-marker__count">
        <span>
          {{ imagesCount }}
        </span>
    </div>
  </div>
</template>

<script>
import Coordinate from "@/models/Coordinate";
import { MglMarker } from "vue-mapbox";
import { mapState, mapGetters, mapActions } from "vuex";
import getCoordinateCoverImage from "@/helpers/getCoordinateCoverImage";
import {getPdfThumbnail} from "@/helpers/pdf-thumbnail"

export default {
  name: "MapMarker",
  components: {
    MglMarker
  },
  props: {
    coordinate: {
      type: Coordinate,
      required: true
    },
    isInMap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pdfThumbnail: null, 
    }
  },
  computed: {
    ...mapState('Coordinates', ['activeCoordinateId']),
    ...mapGetters('Routes', ['activeRoute', 'isCoordinateInActiveRoute']),
   //  pdfUrl() {
   // const pdfItem = this.coordinate.allImages?.find(img => img.srcType === "pdf_file");
   // if (!pdfItem) return null;
   // const fullUrl = `${process.env.VUE_APP_UPLOADS_URL}${pdfItem.srcNumber}`;
   // return fullUrl;
  //},
//    pdfUrls() {
//    const pdfItem = this.coordinate.allImages?.find(img => img.srcType === "pdf_file");
//    if (!pdfItem?.src) return []; 
//     return pdfItem.src.map(url => `${url}`);
//  },
titlePicture() {
  return getCoordinateCoverImage(this.coordinate)?.titlePicture;
},

    isRouteEditing() {
      return this.activeRoute?.isEditing || false
    },
    lnglat() {
      return [this.coordinate.lng, this.coordinate.lat]
    },
    isChosen() {
      return this.coordinate.id === this.activeCoordinateId
    },
    isInActiveRoute() {
      return this.isCoordinateInActiveRoute(this.coordinate.id)
    },
    isActive() {
      return (this.isInActiveRoute && this.isInMap) || this.isChosen
    },
    modifiers() {
      return {
        'map-marker--is-active': this.isActive,
      }
    },
    // imageUrl() {
    //   return (image => image ? image.titlePicture.srcXs : null)(getCoordinateCoverImage(this.coordinate))
    // },
    imageUrl() { 
     return this.pdfThumbnail || (image => image ? image.titlePicture.srcXs : null)(getCoordinateCoverImage(this.coordinate)) },
    imagesCount() {
      return this.coordinate.images?.length || null
    },
    streetLabel() {
      return this.coordinate.streetLabelText
    },

    showRouteControl() {
      return this.isRouteEditing && (this.isInActiveRoute || this.isChosen)
    }
  },
async mounted() {  
  // if (this.pdfUrl) {
  //   this.pdfThumbnail = await getPdfThumbnail(this.pdfUrl, 0.5);
  // } 
  //  if (this.pdfUrls.length > 0) {   
  //     this.pdfThumbnail = await getPdfThumbnail(this.pdfUrls[0], 0.5);
  // }
},
methods: {
    onClick(event) {
      this.$emit('marker-click', this.coordinate, event)
    },
    onRouteControlClick() {
      if (this.isInActiveRoute) {
        this.removeFromRoute()
      } else {
        this.addToRoute()
      }
    },
    addToRoute() {
      this.addCoordinateToRoute({
        routeId: this.activeRoute?.id,
        coordinateId: this.coordinate.id
      })
    },
  //   async generatePdfThumbnail() {
  //   if (this.pdfUrls.length > 0) {
  //     this.pdfThumbnail = await getPdfThumbnail(this.pdfUrls[0], 0.5)
  //   } else {
  //     this.pdfThumbnail = null
  //   }
  // },
  async generatePdfThumbnail() {
  const src = this.titlePicture?.srcSm;

  if (!src) {
    this.pdfThumbnail = null;
    return;
  }

  // If file is PDF
  if (src.toLowerCase().endsWith(".pdf")) {
    try {
      const imgData = await getPdfThumbnail(src, 0.5);
      this.pdfThumbnail = imgData;
    } catch (err) {
      console.error("PDF thumbnail error:", err);
      this.pdfThumbnail = null;
    }
  } else {
    // Normal image
    this.pdfThumbnail = src;
  }
},

    removeFromRoute() {
      this.removeCoordinateFromRoute({
        routeId: this.activeRoute?.id,
        coordinateId: this.coordinate.id
      })
    },
    

    ...mapActions('Routes', ['addCoordinateToRoute', 'removeCoordinateFromRoute'])
  },
  watch: {
  // '$route.query': {
  //   handler() {
  //     this.generatePdfThumbnail()
  //   },
  //   deep: true
  // },

  coordinate: {
    handler() {
      this.generatePdfThumbnail()
    },
    immediate: true
  }
},
// watch: {
//   '$route.query.routeId': {
//     async handler(newVal) {
//       if (newVal && this.coordinate) {
//         await this.generatePdfThumbnail()
//       }
//     },
//     immediate: true
//   },

//   coordinate: {
//     handler() {
//       if (this.$route.query.routeId) {
//         this.generatePdfThumbnail()
//       }
//     },
//     immediate: true
//   }
// }
// watch: {
//   '$route.fullPath': {
//     async handler() {
//       if (this.$route.query.routeId && this.coordinate) {
//         await this.generatePdfThumbnail()
//       }
//     },
//     immediate: true
//   },

//   coordinate: {
//     async handler() {
//       if (this.$route.query.routeId) {
//         await this.generatePdfThumbnail()
//       }
//     },
//     immediate: true
//   }
// }
}
</script>

<style lang="scss">
.map-marker {
  position: relative;
  height: 76px;
  width: 76px;
  border: 4px solid $app-primary-color;
  border-radius: 50%;
  box-shadow: 0 5px 6px rgba(0, 0, 0, 0.5);
  background-color: #FFFFFF;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  transition: border-color 0.35s cubic-bezier(0.4, 0, 0.2, 1);

  &--is-active {
    border-color: $app-primary-accent-color;
    z-index: 10;
  }
  &--is-active &__count {
    border-color: #FFFFFF;
    background: $app-primary-accent-color;
  }

  &__count {
    position: absolute;
    background: linear-gradient(90deg, $app-primary-gradient-color-from 0%, $app-primary-gradient-color-to 100%);
    border: 2px solid #FFFFFF;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 1;
    display: flex;
    height: 25px;
    width: 25px;
    right: -4px;
    top: -4px;
  }

  &__street {
    position: absolute;
    background: $app-primary-accent-color;
    color: white;
    height: 20px;
    line-height: 16px;
    padding: 2px 8px;
    border-radius: 10px;
    top: 54px;
    right: 48px;
    font-size: 16px;
    font-weight: 100;
    font-family: "DINCondensed", sans-serif;

    span {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 120px;
    }
  }

  &__route-control {
    position: absolute;
    right: 10%;
    bottom: 10%;
    transform: translate(50%, 50%);
    border-radius: 50%;

    &--is-inactive {
      cursor: default;
    }
  }

}
</style>
